import { faUsersClass } from '@fortawesome/pro-solid-svg-icons'
import type { ReactElement } from 'react'

import useAPIWrapper from '@/client/hooks/useAPIWrapper'
import RPC from '@/client/rpc'
import type { HostCardSessionHostFragment } from '@/client/services/hasura/generated/graphql'

import UserCard from '@/components/Series/Banners/BreakoutSessionBanner/internal/UserCard'
import { useToaster } from '@/components/Toast/useToaster'
import type { MenuItemType } from '@/components/Worlds/UI/Menu/types'

export default function HostCard({
  breakoutSessionIds,
  host,
}: {
  breakoutSessionIds: number[]
  host: HostCardSessionHostFragment
}): ReactElement {
  const { user } = host
  const toast = useToaster()

  const [moveToBreakoutRoom, movingToBreakoutRoom] = useAPIWrapper(
    async (breakoutSessionId: number) => {
      const roomIndex = breakoutSessionIds.indexOf(breakoutSessionId)
      const roomNumber = roomIndex !== -1 ? roomIndex + 1 : '?'

      toast({
        title: `Moving ${user.virtual_display_name} to Room ${roomNumber}...`,
        status: 'info',
      })

      await RPC.registerUsersForBreakoutSession({
        userIds: [user.id],
        sessionBreakoutId: breakoutSessionId,
      })

      toast({
        title: `${user.virtual_display_name} moved to Room ${roomNumber} successfully`,
        status: 'success',
      })
    },
    [user.id, user.virtual_display_name, breakoutSessionIds, toast],
    'Move User to Breakout Room'
  )

  const menuItems: MenuItemType[][] =
    breakoutSessionIds.length === 0
      ? []
      : [
          breakoutSessionIds.map((breakoutId, index) => ({
            label: `Move to Room ${index + 1}`,
            icon: faUsersClass,
            onClick: () => moveToBreakoutRoom(breakoutId),
            disabled: movingToBreakoutRoom,
          })),
        ]

  return <UserCard user={user} attemptedJoining menuItems={menuItems} />
}
